// src/pages/About.jsx
import styled from "styled-components";
import { FaCode, FaRocket, FaBrain, FaUnity } from "react-icons/fa";

export default function About() {
  return (
    <Wrapper>
      <SectionCard>
        <ProfileSection>
          <Avatar src="/avatar.jpg" alt="Profile" />
          <div>
            <Name>Nishal Dinesh</Name>
            <Role>Full Stack Developer</Role>
          </div>
        </ProfileSection>

        <AboutContent>
          <Heading>About Me</Heading>
          <AccentLine />
          <Text>
            I'm a passionate MERN Stack Developer with over 3 years of experience in building fast, responsive, and dynamic web applications. 
            I focus on creating seamless digital experiences with clean architecture and modern UI design. 
            My work reflects a balance between performance, functionality, and aesthetics.
          </Text>
        </AboutContent>
      </SectionCard>

      <WhatIDoSection>
        <Heading>What I’m Doing</Heading>
        <AccentLine />

        <CardsGrid>
          <ActivityCard>
            <IconWrapper><FaCode /></IconWrapper>
            <h4>Web Development</h4>
            <p>
              I build scalable, high-performance websites using React, Node.js, and Express — optimized for both speed and design.
            </p>
          </ActivityCard>
          <ActivityCard>
            <IconWrapper><FaUnity /></IconWrapper>
            <h4>Game Development</h4>
            <p>
             Recently started exploring game development using Unity, expanding my creativity beyond web apps into interactive 3D experiences.
            </p>
          </ActivityCard>

          <ActivityCard>
            <IconWrapper><FaRocket /></IconWrapper>
            <h4>Startup Projects</h4>
            <p>
              I collaborate with startups to transform ideas into production-ready web products with smooth, responsive UIs.
            </p>
          </ActivityCard>

          <ActivityCard>
            <IconWrapper><FaBrain /></IconWrapper>
            <h4>Continuous Learning</h4>
            <p>
              Always exploring new technologies, design systems, and architecture patterns to improve efficiency and scalability.
            </p>
          </ActivityCard>
        </CardsGrid>
      </WhatIDoSection>
    </Wrapper>
  );
}

// 💠 Styled Components

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 2rem 2rem 3rem 2rem;

  @media (max-width: 768px) {
   padding: 6rem 0rem 3rem 0rem;
  }
`;

const SectionCard = styled.div`
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
`;

const ProfileSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 1.2rem;
`;

const Avatar = styled.img`
  width: 90px;
  height: 90px;
  border-radius: 18px;
  border: 2px solid ${({ theme }) => theme.accent};
  object-fit: cover;
`;

const Name = styled.h2`
  font-size: 1.4rem;
  margin-bottom: 0.3rem;
`;

const Role = styled.p`
  font-size: 0.95rem;
  opacity: 0.7;
`;

const AboutContent = styled.div`
  margin-top: 0.5rem;
`;

const Heading = styled.h3`
  font-size: 1.3rem;
  margin-bottom: 0.6rem;
`;

const AccentLine = styled.div`
  width: 40px;
  height: 4px;
  background-color: ${({ theme }) => theme.accent};
  border-radius: 4px;
  margin-bottom: 1rem;
`;

const Text = styled.p`
  line-height: 1.7;
  opacity: 0.9;
`;

const WhatIDoSection = styled(SectionCard)`
  display: flex;
  flex-direction: column;
`;

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-top: 1.5rem;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`;

const ActivityCard = styled.div`
  background-color: ${({ theme }) => theme.background};
  border-radius: 14px;
  padding: 1.5rem;
  transition: all 0.3s ease;
  border: 1px solid ${({ theme }) => theme.border};
  text-align: left;

  &:hover {
    background-color: ${({ theme }) => theme.hover};
    color: #fff;
    transform: translateY(-5px);
  }

  h4 {
    margin-top: 0.8rem;
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 0.9rem;
    opacity: 0.85;
  }
`;

const IconWrapper = styled.div`
  font-size: 2rem;
  color: ${({ theme }) => theme.accent};
`;

